import React from 'react';
import Drawer from '../../ui/drawer';
import InfoSize from './components/info-size';
export default function SampleSizePopup(props) {
  const {
    open,
    onClose
  } = props;
  return /*#__PURE__*/React.createElement(Drawer, {
    dataDrawer: "ProductSize",
    open: open,
    onClose: onClose,
    headerTitle: "Size of the product"
  }, /*#__PURE__*/React.createElement(InfoSize, {
    onClose: onClose
  }));
}